// Verb form labels and definitions for the frontend
// These correspond to the VerbForm enum in the backend

export interface VerbFormLabel {
  value: string; // The enum name (e.g., "PRESENT_DICTIONARY")
  japaneseName: string; // Japanese name (e.g., "辞書形")
  englishName: string; // English name (e.g., "Dictionary form")
  description: string; // Description (e.g., "Plain present")
  category: string; // Category for grouping (e.g., "Present forms")
}

export const VERB_FORMS: VerbFormLabel[] = [
  // Present forms
  {
    value: 'PRESENT_DICTIONARY',
    japaneseName: '辞書形',
    englishName: 'Dictionary form',
    description: 'Plain present',
    category: 'Present forms',
  },
  {
    value: 'PRESENT_POLITE',
    japaneseName: 'ます形',
    englishName: 'Polite form',
    description: 'Polite present',
    category: 'Present forms',
  },
  {
    value: 'PRESENT_DICTIONARY_NEGATIVE',
    japaneseName: '辞書形(否定)',
    englishName: 'Dictionary form negative',
    description: 'Plain present negative',
    category: 'Present forms',
  },
  {
    value: 'PRESENT_POLITE_NEGATIVE',
    japaneseName: 'ません形',
    englishName: 'Polite form negative',
    description: 'Polite present negative',
    category: 'Present forms',
  },
  
  // Past forms
  {
    value: 'PAST_PLAIN',
    japaneseName: 'た形',
    englishName: 'Past form',
    description: 'Plain past',
    category: 'Past forms',
  },
  {
    value: 'PAST_POLITE',
    japaneseName: 'ました形',
    englishName: 'Polite past',
    description: 'Polite past',
    category: 'Past forms',
  },
  {
    value: 'PAST_PLAIN_NEGATIVE',
    japaneseName: 'なかった形',
    englishName: 'Past form negative',
    description: 'Plain past negative',
    category: 'Past forms',
  },
  {
    value: 'PAST_POLITE_NEGATIVE',
    japaneseName: 'ませんでした形',
    englishName: 'Polite past negative',
    description: 'Polite past negative',
    category: 'Past forms',
  },
  
  // Te-form
  {
    value: 'TE_FORM',
    japaneseName: 'て形',
    englishName: 'Te-form',
    description: 'Connecting form',
    category: 'Te-form',
  },
  {
    value: 'TE_FORM_NEGATIVE',
    japaneseName: 'なくて形',
    englishName: 'Te-form negative',
    description: 'Connecting form negative',
    category: 'Te-form',
  },
  
  // Potential forms
  {
    value: 'POTENTIAL',
    japaneseName: '可能形',
    englishName: 'Potential',
    description: 'Can do',
    category: 'Potential forms',
  },
  {
    value: 'POTENTIAL_NEGATIVE',
    japaneseName: '可能形(否定)',
    englishName: 'Potential negative',
    description: 'Cannot do',
    category: 'Potential forms',
  },
  
  // Passive forms
  {
    value: 'PASSIVE',
    japaneseName: '受身形',
    englishName: 'Passive',
    description: 'Passive',
    category: 'Passive forms',
  },
  {
    value: 'PASSIVE_NEGATIVE',
    japaneseName: '受身形(否定)',
    englishName: 'Passive negative',
    description: 'Passive negative',
    category: 'Passive forms',
  },
  
  // Causative forms
  {
    value: 'CAUSATIVE',
    japaneseName: '使役形',
    englishName: 'Causative',
    description: 'Make/let do',
    category: 'Causative forms',
  },
  {
    value: 'CAUSATIVE_NEGATIVE',
    japaneseName: '使役形(否定)',
    englishName: 'Causative negative',
    description: "Don't make/let do",
    category: 'Causative forms',
  },
  
  // Causative passive forms
  {
    value: 'CAUSATIVE_PASSIVE',
    japaneseName: '使役受身形',
    englishName: 'Causative passive',
    description: 'Made to do',
    category: 'Causative passive forms',
  },
  {
    value: 'CAUSATIVE_PASSIVE_NEGATIVE',
    japaneseName: '使役受身形(否定)',
    englishName: 'Causative passive negative',
    description: 'Not made to do',
    category: 'Causative passive forms',
  },
  
  // Imperative forms
  {
    value: 'IMPERATIVE',
    japaneseName: '命令形',
    englishName: 'Imperative',
    description: 'Command',
    category: 'Imperative forms',
  },
  {
    value: 'IMPERATIVE_NEGATIVE',
    japaneseName: '命令形(否定)',
    englishName: 'Imperative negative',
    description: "Don't command",
    category: 'Imperative forms',
  },
];

// Group verb forms by category
export const VERB_FORMS_BY_CATEGORY: Record<string, VerbFormLabel[]> = VERB_FORMS.reduce(
  (acc, form) => {
    if (!acc[form.category]) {
      acc[form.category] = [];
    }
    acc[form.category].push(form);
    return acc;
  },
  {} as Record<string, VerbFormLabel[]>
);

